import { pathOr } from 'ramda';
import { createSelector } from 'reselect';

import { isObject } from '@ezugi/utils';

import { RootState } from '../types';

type GenericBetEntry = {
  current: Record<string, unknown>;
  totalBet: number;
}

export type GenericBets = GenericBetEntry & {
  history: GenericBetEntry[];
  last?: GenericBetEntry;
}

export type RootStateWithBets = RootState & { bets: GenericBets };

const defaultValue: GenericBets = {
  current: {},
  totalBet: 0,
  history: [],
};

const EMPTY = {};

export const betsSelector = (state: RootStateWithBets) => state.bets || defaultValue;

export const currentBetsSelector = createSelector(
  betsSelector,
  (bets) => bets.current || defaultValue.current
);

export const hasBetsSelector = createSelector(
  currentBetsSelector,
  (currentBets) => Object.keys(currentBets).length > 0
);

export const lastBetsSelector = createSelector(
  betsSelector,
  (bets) => bets.last || defaultValue.last
);

export const hasLastBetsSelector = createSelector(
  lastBetsSelector,
  (lastBets) => lastBets && Object.keys(lastBets).length > 0
);

const betsHistorySelector = createSelector(
  betsSelector,
  (bets) => bets.history || EMPTY
);

export const hasBetsHistorySelector = createSelector(
  betsHistorySelector,
  (betHistory) => (Array.isArray(betHistory) && betHistory.length > 0)
   || (isObject(betHistory) && Object.keys(betHistory).length > 0)
);

// on some games e.g Matka we don't have initial bet history, but on others we have totalBet 0 entry.
export const noBetHistorySelector = createSelector(
  betsHistorySelector,
  (betsHistory) => (betsHistory.length === 0 || (betsHistory.length === 1 && betsHistory[0].totalBet === 0))
);

export const totalBetSelector = pathOr(0, [ 'bets', 'totalBet' ]);
